import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-content-panel-vehicle',
  templateUrl: './skeleton-content-panel-vehicle.component.html',
  styleUrls: ['./skeleton-content-panel-vehicle.component.scss'],
})
export class SkeletonContentPanelVehicleComponent {}
